import { FlagType } from 'src/app/slice';

export const formatFlagType = (tag?: string): FlagType => {
  return (tag?.toLowerCase() as FlagType) || 'beta';
};

export const formatFlagLabel = (flagLabel: string): string => {
  return flagLabel.charAt(0).toUpperCase() + flagLabel.slice(1).toLowerCase();
};
